import React, { useState, useRef, useEffect } from "react";
import bott from "../assets/images/bott.png";
import cancel from "../assets/images/bot4.png";
import refresh from "../assets/images/bot8.png";
import smile from "../assets/images/bot3.png";
import attach from "../assets/images/bot6.png";
import mic from "../assets/images/bot2.png";
import send from "../assets/images/bot7.png";
import "../assets/styles/chat.css";

const ChatPopup = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hello, Welcome to Syncrones!" },
    // { type: "user", text: "I need meeting for discuss related my web site" },
    // { type: "bot", text: "Yes, sure!" },
  ]);
  const [inputText, setInputText] = useState("");

  const endOfMessagesRef = useRef(null);
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    // Set current date and time
    const date = new Date();
    const formattedDate = `${date.getDate()} ${date.toLocaleString("default", {
      month: "long",
    })} ${date.getFullYear()} ${date.toLocaleTimeString()}`;
    setCurrentDate(formattedDate);

    // Scroll to the last message whenever messages change
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleSend = async () => {
    if (!inputText.trim()) return;

    const userMessage = { type: "user", text: inputText };
    setMessages((prev) => [...prev, userMessage]);

    try {
      const response = await fetch("https://bot.syncturma.com/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_input: inputText }),
      });

      const data = await response.json();
      const botMessage = { type: "bot", text: data.response };
      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("Chat error:", error);
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "Something went wrong. Please try again later." },
      ]);
    }

    setInputText("");
  };

  return (
    <div
      className="chat-popup"
      style={{
        width: "370px",
        height: "490px",
        border: "1px solid #ccc",
        borderRadius: "20px",
        overflow: "hidden",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        fontFamily: "Inter, sans-serif",
        zIndex: 1000,
      }}
    >
      {/* Header */}
      <div
        className=" flex justify-between items-center border-b px-4 py-2 shadow-sm bg-white"
        style={{
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          borderBottom: "0.5px solid rgba(0, 0, 0, 0.2)",
        }}
      >
        <img
          src={bott}
          alt="Bot Icon"
          style={{ width: "40px", height: "40px", marginRight: "20px" }}
        />
        <span
          className="flex items-center ml-8 font-semibold"
          style={{ fontSize: "16px", fontWeight: 600 }}
        >
          Chat Assistant
        </span>
        <img
          src={refresh}
          alt="Refresh"
          style={{
            width: "20px",
            height: "20px",
            marginLeft: "90px",
            cursor: "pointer",
          }}
          onClick={() => {
            setMessages([
              { type: "bot", text: "Hello, Welcome to Syncrones!" },
            ]);
            setInputText("");

            const date = new Date();
            const formattedDate = `${date.getDate()} ${date.toLocaleString(
              "default",
              {
                month: "long",
              }
            )} ${date.getFullYear()} ${date.toLocaleTimeString()}`;
            setCurrentDate(formattedDate);
          }}
        />

        <img
          src={cancel}
          alt="Close"
          style={{
            width: "15px",
            height: "15px",
            marginLeft: "15px",
            cursor: "pointer",
          }}
          onClick={onClose}
        />
      </div>

      {/* Chat Body */}
      <div
        className="chat-scroll-container"
        style={{
          flex: 1,
          padding: "20px",
          overflowY: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "8px 0",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            color: "#000",
          }}
        >
          <div
            style={{ flex: 1, height: "1px", backgroundColor: "#999" }}
          ></div>
          <div style={{ padding: "0 10px", whiteSpace: "nowrap" }}>
            {currentDate}
          </div>
          <div
            style={{ flex: 1, height: "1px", backgroundColor: "#999" }}
          ></div>
        </div>

        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: msg.type === "user" ? "flex-end" : "flex-start",
              marginBottom: "38px",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                backgroundColor: msg.type === "bot" ? "#5D6EF3" : "#e0e0e0",
                color: msg.type === "bot" ? "#ffffff" : "#000000",
                borderRadius: "20px",
                border: "0.1px solid rgba(0, 0, 0, 0.2)",
                padding: "10px 14px",
                maxWidth: "70%",
                fontSize: "14px",
                position: "relative",
              }}
            >
              {msg.text}
            </div>
          </div>
        ))}

        <div ref={endOfMessagesRef} />
      </div>

      {/* Message Input Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#E9E9E9",
          padding: "10px",
          border: "0.1px solid rgba(0, 0, 0, 0.2)",
          borderRadius: "30px",
          margin: "0 20px 10px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
        }}
      >
        {/* Mic Icon */}
        {/* <img
          src={mic}
          alt="Mic"
          style={{
            width: "18px",
            height: "18px",
            marginRight: "10px",
            marginLeft: "12px",
          }}
        /> */}

        {/* Input Field */}
        <input
          type="text"
          placeholder="Enter message"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          style={{
            flex: 1,
            border: "none",
            marginLeft: "10px",
            outline: "none",
            backgroundColor: "transparent",
            fontSize: "14px",
            color: "#000",
          }}
        />

        {/* Send Icon */}
        <img
          src={send}
          alt="Send"
          onClick={handleSend}
          style={{
            width: "20px",
            height: "20px",
            marginLeft: "10px",
            cursor: "pointer",
            marginRight: "15px",
          }}
        />
      </div>

      {/* Bottom Icon Row */}
      <div
        style={{
          display: "flex",
          marginLeft: "22px",
          justifyContent: "left",
          alignItems: "left",
          paddingTop: "5px",
          paddingBottom: "10px",
          backgroundColor: "#ffffff",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          gap: "20px",
        }}
      >
        {/* <img
          src={smile}
          alt="Emoji"
          style={{ width: "24px", height: "24px" }}
        />
        <img
          src={attach}
          alt="Attach"
          style={{ width: "24px", height: "24px" }}
        /> */}
      </div>
    </div>
  );
};

export default ChatPopup;
